<div class="actions">
	@if (!isReached1530ET()) {
		<app-button
			appearance="secondary"
			size="s"
			[isDisabled]="openedDropdown() === dropdownVariantEnum.POSITION_OPTION_INFO"
			[tuiDropdownMinHeight]="600"
			[tuiDropdownMaxHeight]="600"
			[tuiDropdown]="positionInfoDropdown"
			[tuiDropdownManual]="openedDropdown() === dropdownVariantEnum.POSITION_OPTION_INFO"
			(clicked)="toggleDropdown(dropdownVariantEnum.POSITION_OPTION_INFO)"
		>
			{{ 'positions.info' | translate }}
		</app-button>

		<app-button
			appearance="secondary"
			size="s"
			[isDisabled]="openedDropdown() === dropdownVariantEnum.POSITION_OPTION_CLOSE"
			[tuiDropdownMinHeight]="600"
			[tuiDropdownMaxHeight]="600"
			[tuiDropdown]="positionCloseDropdown"
			[tuiDropdownManual]="openedDropdown() === dropdownVariantEnum.POSITION_OPTION_CLOSE"
			(clicked)="toggleDropdown(dropdownVariantEnum.POSITION_OPTION_CLOSE)"
		>
			{{ 'positions.close' | translate }}
		</app-button>

		@if (canExecuteOption()) {
			<app-button
				appearance="secondary"
				size="s"
				[isDisabled]="openedDropdown() === dropdownVariantEnum.POSITION_OPTION_EXECUTION"
				[tuiDropdownMinHeight]="600"
				[tuiDropdownMaxHeight]="600"
				[tuiDropdown]="positionExecutionDropdown"
				[tuiDropdownManual]="openedDropdown() === dropdownVariantEnum.POSITION_OPTION_EXECUTION"
				(clicked)="toggleDropdown(dropdownVariantEnum.POSITION_OPTION_EXECUTION)"
			>
				{{ 'positions.execution' | translate }}
			</app-button>
		}
	} @else {
		<span class="text">{{ 'positions.status.accepted' | translate }}</span>
	}
</div>

<ng-template #positionInfoDropdown>
	<div
		appClickOutside
		(clickOutside)="onClickOutside()"
	>
		<app-position-option-info
			[position]="option()"
			(closeDropdown)="toggleDropdown(null)"
		/>
	</div>
</ng-template>

<ng-template #positionCloseDropdown>
	<div
		appClickOutside
		(clickOutside)="onClickOutside()"
	>
		<app-position-option-close
			[position]="option()"
			(closeDropdown)="toggleDropdown(null)"
		/>
	</div>
</ng-template>

<ng-template #positionExecutionDropdown>
	<div
		appClickOutside
		(clickOutside)="onClickOutside()"
	>
		<app-position-option-execution
			[position]="option()"
			(closeDropdown)="toggleDropdown(null)"
		/>
	</div>
</ng-template>
